<template>
  <div>
    <h1 class="bigtitle">培训信息<router-link :to="`/news/views/${plateIdInfo}/${childPlateId}`"></router-link></h1>
    <div class="leftInfo">
      <el-carousel :interval="5000" arrow="never" style="width: 569px;" width="569px" height="408px">
        <el-carousel-item v-for="item in picItems" :key="item.id">
          <a :href="item.url ? item.url : `/news/info/${item.plateid}/${item.uuid}`" :target="item.url ? '_blank' : '_self'">
            <img :src="`${IP_TEST}/uploads/${item.picsrc}`" width="569" height="408" alt="" />
            <div class="htitle"><h1>{{ item.title }}</h1></div>
          </a>
        </el-carousel-item>
      </el-carousel>
      <ul class="list">
        <li v-for="(item,index) in infos.slice(0,5)" :key="item.id" :class="'itemli' + index">
          <router-link :to="`/news/info/${item.plateid}/${item.uuid}`" tag="h3" :title="item.title">
            {{ item.title}}  
          </router-link>
          <p class="description">{{ item.description }}</p>
          <span class="day">{{ item.addtime | dayfilter }}</span>
          <span class="year">{{ item.addtime | yearfilter }}</span>
          <router-link :to="`/news/info/${item.plateid}/${item.uuid}`" :title="item.title">  
          </router-link>
        </li>
      </ul> 
    </div> 
  </div>
  
</template>

<script>
import { getNewsViews, getPlatePicNews,getPlatePicNewEx } from '@/request/get'
import { IP_TEST } from '@/config'
export default {
  name: "IntegratedService",
  components: {
  },
  data() {
    return {
      IP_TEST,
      activeInfoIndex: 0,
      activepxInfoIndex:0,
      infos: [],
      picItems:[],//带图片的内容
      plateIdInfo: "",
      childPlateId:"",
      plateIdNative:"",
      pxinfos: [],
      natives:[],
      smNatives:[],
      picpxItems: { picsrc: '', title: '', description: '', plateid:'' },//带图片的内容
      pxPlateIdInfo: "",
      pxChildPlateId:"",
      smChildPlateId:""
    }
  },
  filters: {
    datefilter(value) {
      return value.slice(0,10);
    },
     dayfilter(value) {
      return value.slice(8, 10);
    },
    yearfilter(value) {
      return value.slice(0, 7).replace(/-/g, '.');
    }
  },
  created() {
    this.changeInfo(0, '培训项目','培训安排'); 
    
  },
  mounted() {
  },
  methods: {
    async getNewsViews(uuid,childuuid) {
      let result = await getNewsViews(uuid, 1,5,childuuid);
      result = result.data;
      this.infos = result || [];
      //this.getPicItem();
      this.getPicNews();
    },
    async getPicNews() {
      let result = await getPlatePicNewEx(this.plateIdInfo, this.childPlateId);
      result = result.data;
      this.picItems = result || [];
    },
    changeInfo(index, name,childname) {
      this.activeInfoIndex = index
      let { plates } = this.$store.state;
      let plate = plates.filter(plate => plate.name == name);
      this.plateIdInfo = plate[0].uuid;
      let childPlate = plate[0].CategoryChildren.filter(item => item.name == childname);
      this.childPlateId = childPlate[0].uuid;
      this.getNewsViews(this.plateIdInfo,this.childPlateId);
    },    
    /**
     * 获取带图片的项
     */
    getPicItem() {
      let result = this.infos.filter(item => item.picsrc != '' && item.picsrc != null);
      this.picItems = result.length > 0 && result[0];
    },
    
    async getpxNewsViews(uuid,childuuid) {
      let result = await getPlatePicNewEx(uuid, 1,3,childuuid);
      result = result.data;
      this.pxinfos = result || [];
      this.getpxPicItem();
    },

    changepxInfo(index, name,childname) {
      this.activepxInfoIndex = index
      let { plates } = this.$store.state;
      let plate = plates.filter(plate => plate.name == name);
      this.pxPlateIdInfo = plate[0].uuid;
      let childPlate = plate[0].CategoryChildren.filter(item => item.name == childname);
      this.pxChildPlateId = childPlate[0].uuid;
      this.getpxNewsViews(this.pxPlateIdInfo,this.pxChildPlateId);
    },
    /**
     * 获取带图片的项
     */
    getpxPicItem() {
      let result = this.pxinfos.filter(item => item.picsrc != '' && item.picsrc != null);
      this.pxPicItems = result.length > 0 && result[0];
    },
    async getNatives(){
      let { plates } = this.$store.state;
      let plate = plates.filter(plate => plate.name == '通知公告');
      this.plateIdNative = plate[0].uuid;
      let childPlate = plate[0].CategoryChildren.filter(item => item.name == '公示公告');
      let result = await getNewsViews(this.plateIdNative, 1,10,childPlate[0].uuid);
      result = result.data.concat(result.data);
      this.natives = result || [];
      childPlate = plate[0].CategoryChildren.filter(item => item.name == '声明公告');
      this.smChildPlateId = childPlate[0].uuid;
      result = await getNewsViews(this.plateIdNative, 1,10,childPlate[0].uuid);
      result = result.data;
      this.smNatives = result || [];
    }
  }
};
</script>
<style scoped>
.leftInfo{
  display: flex;
  justify-content: space-between;
}
.list{
  position: relative;
  width: 731px;
  height: 408px;
}
.list li.itemli0,.list li.itemli1{
  position: relative;
  margin-left: 19px;
width: 340px;
height: 197px;
background: #2E8EEB;
}
.list li.itemli1{
  margin-top: 14px;
background: #F4F9FF;
}
.list li.itemli0 h3,.list li.itemli1 h3{
  position: absolute;
  top:25px;
  left: 28px;
  width: 261px;
height: 16px;
font-size: 16px;
font-family: PingFang SC;
font-weight: 500;
color: #FFFFFF;
line-height: 16px;
 -webkit-background-clip: text;
    word-break: break-all;
  -webkit-box-orient: vertical;
        white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  -webkit-line-clamp: 1;
}
.list li.itemli2 h3,.list li.itemli3 h3,.list li.itemli4 h3{
  display: none;
}
.list li.itemli0 p,.list li.itemli1 p{
  position: absolute;
  top:56px;
  left: 29px;
width: 290px;
height: 35px;
font-size: 14px;
font-family: PingFang SC;
font-weight: 500;
color: #FFFFFF;
line-height: 19px;
opacity: 0.8;
 overflow: hidden;
      word-break: break-all;
    overflow: hidden;
-webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.list li.itemli0::after,.list li.itemli1::after{
  position: absolute;
  top:106px;
  left:32px;
  content: '';
  width: 284px;
    height: 1px;
    background: #D8D9DA;
    opacity: 0.4;

}
.list li.itemli2 p,.list li.itemli3 p,.list li.itemli4 p{
     position: absolute;
  top:29px;
  left: 117px;
  width: 223px;
height: 40px;
font-size: 16px;
font-family: PingFang SC;
font-weight: 500;
color: #333333;
line-height: 20px;
 overflow: hidden;
      word-break: break-all;
    overflow: hidden;
-webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.list li.itemli2 .day,.list li.itemli3 .day,.list li.itemli4 .day{
     position: absolute;
  top:28px;
  left: 20px;
width: 28px;
height: 28px;
font-size: 28px;
font-family: PingFang SC;
font-weight: bold;
color: #333333;
line-height: 28px;
}
.list li.itemli0 .day,.list li.itemli1 .day{
   position: absolute;
  top:128px;
  left: 33px;
height: 28px;
font-size: 28px;
font-family: PingFang SC;
font-weight: bold;
color: #FFFFFF;
line-height: 28px;
}
.list li.itemli2 .year,.list li.itemli3 .year,.list li.itemli4 .year{
   position: absolute;
  top:78px;
  left: 20px;
height: 14px;
font-size: 14px;
font-family: PingFang SC;
font-weight: 500;
color: #999999;
line-height: 14px;
}
.list li.itemli0 .year,.list li.itemli1 .year{
   position: absolute;
  top:162px;
  left: 33px;
height: 14px;
font-size: 14px;
font-family: PingFang SC;
font-weight: 500;
color: #FFFFFF;
line-height: 14px;
}
.list li.itemli2 a,.list li.itemli3 a,.list li.itemli4 a{
    position: absolute;
  top:92px;
  left: 121px;
  width: 19px;
height: 12px;
background-image: url(/static/img/img/jiantuoxinyou.png);
background-repeat: no-repeat;
}
.list li.itemli0 a,.list li.itemli1 a{
   position: absolute;
  top:133px;
  left: 277px;
  width: 26px;
height: 26px;
background-image: url(/static/img/img/yuanyuo.png);
background-repeat: no-repeat;
}
.list li.itemli1 a{
  background-image: url(/static/img/img/huiseyouobian.png);
}

.list li.itemli1 p,.list li.itemli1 .year{
  color: #999999;
}
.list li.itemli1 h3,.list li.itemli1 .day{
  color: #333333;
}
.list li.itemli2,.list li.itemli3,.list li.itemli4{
  position: absolute;
  
  width: 351px;
height: 126px;
background: #F4F9FF;
}
.list li.itemli2{
  top:0;
  right:0;
}
.list li.itemli4{
  bottom: 0;
  right:0;
}
.list li.itemli3{
  top: 141px;
  right:0;
}
 .bigtitle {
  position: relative;
  height: 24px;
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #2E8EEB;
padding-left: 25px;
  margin-top: 54px;
  margin-bottom: 46px;
}
.bigtitle:before {
  position: absolute;
  top:0;
  left: 0;
  content: "";
  display: inline-block;
  width: 8px;
  height: 24px;
  background: #2E8EEB;
}
.bigtitle>a{
  position: absolute;
  padding-right: 32px;
  right:0px;
  height: 24px;
  font-size: 14px;
  font-weight: normal;
  color: #999999;
  line-height: 24px;
  background: url(/static/img/img/youbi.png) no-repeat 12px 12px;
  background-position: center right;
}
div >>>.el-carousel__indicators .is-active button{ 
  background: #2E8EEB;
}
div >>>.el-carousel__indicators button{ 
  width: 10px;
height: 10px;
background: #F7F7F7;
border-radius: 50%;
}
div >>>.el-carousel__indicators--horizontal{
  width: 100%;
  height: 44px;
  text-align: right;
  padding-right: 38px;
}
div >>>.el-carousel__item .htitle{
  position: absolute;
  left: 0;
  bottom: 0;
  width: 569px;
    height: 52px;
    background: #000000;
    opacity: 0.6;
}
div >>>.el-carousel__item .htitle h1{
      width: 301px;
      padding-left: 16px;
height: 52px;
font-size: 18px;
font-family: PingFang SC;
color: #F7F7F7;
line-height: 52px;
 -webkit-background-clip: text;
    word-break: break-all;
  -webkit-box-orient: vertical;
        white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  -webkit-line-clamp: 1;
}
</style>
